import PropTypes from 'prop-types';

import { stepsFactory } from 'components/Booking-new/utils/steps';

import RescheduleContainer from './RescheduleContainer';

import VariantA from './Variants/VariantA';

const rescheduleVariants = {
  a: VariantA,
};
const rescheduleWrapper = RescheduleContainer;

const Reschedule = ({ variant, data, navigation, userData }) => {
  return stepsFactory(rescheduleVariants, variant, { data, navigation, userData }, rescheduleWrapper);
};

Reschedule.propTypes = {
  variant: PropTypes.oneOf(['a', 'b']),
  data: PropTypes.shape({
    name: PropTypes.string,
    enableCancellationFlow: PropTypes.bool,
    hoursToCancel: PropTypes.number,
    cancelQuestion: PropTypes.string,
    cancelButtonLabel: PropTypes.string,
    GoodbyeSentence: PropTypes.string,
    cancellationNote: PropTypes.string,
    surveyBeforeCancelling: PropTypes.shape({
      __typename: PropTypes.string,
      id: PropTypes.string,
      successMessage: PropTypes.string,
      surveyOptionsList: PropTypes.shape({
        optionsList: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            name: PropTypes.string,
          }),
        ),
      }),
      title: PropTypes.string,
    }),
    successModal: PropTypes.shape({
      __typename: PropTypes.string,
      id: PropTypes.string,
      successMessage: PropTypes.string.isRequired,
      heading: PropTypes.string,
      description: PropTypes.string,
      emailLabel: PropTypes.string,
      emailError: PropTypes.string,
      marketingConsentLabel: PropTypes.string,
      marketingLabelError: PropTypes.string,
      subscriptionSuccessMessage: PropTypes.string,
    }),
  }),
};

export default Reschedule;
